import { createIcon } from "@chakra-ui/icons";

const Minus = createIcon({
  displayName: "Minus",
  viewBox: "0 0 24 24",
  path: [
    <path
      d="M5 12H19"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      key="QJgy"
    ></path>,
  ],
  defaultProps: { boxSize: 4 },
});

export default Minus;
